import React, { FunctionComponent } from "react"
import { Helmet } from "react-helmet"

const CopilotBanner: FunctionComponent = () => (
  <Helmet
    script={[
      {
        src: "https://copilot.breezy.io/e.js",
        "data-creative": "breezy-copilot-300x600-animated.gif",
        "data-position": "left",
      },
    ]}
  />
)

export default CopilotBanner
